import {createRoot} from 'react-dom/client'
// Axios
import axios from 'axios'
import {Chart, registerables} from 'chart.js'
import {
  ApolloClient,
  InMemoryCache,
  ApolloProvider,
  gql,
  ApolloLink,
  HttpLink,
} from '@apollo/client'
// Apps
import {MetronicI18nProvider} from './_metronic/i18n/Metronici18n'
/**
 * TIP: Replace this style import with rtl styles to enable rtl mode
 *
 * import './_metronic/assets/css/style.rtl.css'
 **/
import './_metronic/assets/sass/style.scss'
import './_metronic/assets/sass/plugins.scss'
import './_metronic/assets/sass/style.react.scss'
import {AppRoutes} from './app/routing/AppRoutes'
import {AuthProvider, setupAxios} from './app/modules/auth'
import {SocketProvider} from './app/config/socket.init'
/**
 * Creates `axios-mock-adapter` instance for provided `axios` instance, add
 * basic Metronic mocks and returns it.
 *
 * @see https://github.com/ctimmerm/axios-mock-adapter
 */
/**
 * Inject Metronic interceptors for axios.
 *
 * @see https://github.com/axios/axios#interceptors
 */
setupAxios(axios)
Chart.register(...registerables)

// const queryClient = new QueryClient()
const container = document.getElementById('root')

const DEV_LINK = process.env.REACT_APP_BACKEND_API_URL

//const DEV_LIVE = 'http://44.209.144.99:8080/api/v1/admin/'

// const SERVER_URL = process.env.REACT_APP_SERVER_URL?.toString()

const httpLink = new HttpLink({
  uri: DEV_LINK,
  headers: {
    'Content-Type': 'application/json',
  }
})

const authLink = new ApolloLink((operation, forward) => {
  // Retrieve the authorization token from local storage.
  const token = localStorage.getItem('accessToken')

  // Debug: Log the operation being sent
  console.log('Apollo Client - Operation:', operation.operationName)
  console.log('Apollo Client - Query:', operation.query.loc?.source?.body)
  console.log('Apollo Client - Variables:', operation.variables)
  console.log('Apollo Client - Token exists:', !!token)

  // Use the setContext method to set the HTTP headers.
  operation.setContext({
    headers: {
      authorization: token ? `Bearer ${token}` : '',
      'Content-Type': 'application/json',
    },
  })

  // Call the next link in the middleware chain.
  return forward(operation).map(result => {
    console.log('Apollo Client - Response:', result)
    return result
  })
})

const client = new ApolloClient({
  link: authLink.concat(httpLink),
  cache: new InMemoryCache({addTypename: false}),
  defaultOptions: {
    watchQuery: {
      fetchPolicy: 'no-cache',
    },
    query: {
      fetchPolicy: 'no-cache',
    },
    mutate: {
      fetchPolicy: 'no-cache',
    },
  },
})

client.query({
  query: gql`
    query GetAdmin {
      admin {
        _id
        name
      }
    }
  `,
})

if (container) {
  createRoot(container).render(
    <>
      <ApolloProvider client={client}>
        <SocketProvider>
          <MetronicI18nProvider>
            <AuthProvider>
              <AppRoutes />
            </AuthProvider>
          </MetronicI18nProvider>
        </SocketProvider>
        {/* <ReactQueryDevtools initialIsOpen={false} /> */}
      </ApolloProvider>
    </>
  )
}
